import { Company } from './company.interface';
import { ValueOf } from './shared.interface';

// List API is returning the full interface still
export interface CustomerInList {
  id: string;
  vatNumber: string;
  companyName: string;
  currency: Currency;
  customerType: CustomerType;
  customerSubtotal: string; // numeric(10,2)
  supplierSubtotal: string; // numeric(10,2)
  createdAt: string;
}

export interface Customer extends CustomerInList {
  doyId: string;
  doy: Doy;
  email: string;
  phoneNumber: string;
  profession: string;
  address: string;
  city: string;
  postalCode: string;
  vatPercentage: string;
  companyId: string;
  company: Company;
  customerTypeId: number;
  currencyId: number;
  countryId: number;
  country: Country;
  vatRegimeId: number;
  vatRegime: CustomerVatRegime;
  vatExceptionCategoryId: number;
  vatExceptionCategory: any;
  shipping: string[];
  rfPaymentCode: string | null;
  updatedAt: string;
  canEditCurrency?: boolean;
  canDelete?: boolean;
}

export interface Doy {
  id: number;
  name: string;
  description: string;
  aadeCode: string;
  createdAt: string;
  updatedAt: string;
}

export interface Country {
  id: number;
  name: string;
  description: string;
  aadeCode: string;
  code: COUNTRY_CODE;
  region: string;
  currencyCode: string;
  languageCode: string;
  diallingCode: string;
  customerTypeId: string;
  customerType: any;
}

export interface CustomerType {
  id: number;
  name: string;
  aadeCode: ValueOf<typeof CUSTOMER_TYPE_AADE_CODE>;
  description: string;
}

export const CUSTOMER_TYPE_AADE_CODE = {
  SAME_COUNTRY_CLIENT: '1455',
  EU_CLIENT: '1456',
  REST_OF_THE_WORLD_CLIENT: '1457',
  PERSON: '1458',
} as const;

export interface CustomerVatRegime {
  id: number;
  name: string;
  description: string;
  aadeId: string;
  aadeCode: ValueOf<typeof CUSTOMER_VAT_REGIME_AADE_CODE>;
}

export const CUSTOMER_VAT_REGIME_AADE_CODE = {
  NORMAL_VAT: '1',
  REDUCED_VAT: '2',
  ZERO_VAT: '3',
} as const;

export interface Currency {
  id: number;
  name: string;
  description: string;
  aadeCode: string;
  currencyCode: string;
}

export interface VatExceptionCategory {
  id: number;
  name: string;
  aadeCode: string;
  description: string;
}

export enum COUNTRY_CODE {
  GR = 'GR',
}
